<template>
  <section id="home-slider" v-if="sliders.length > 0">

    <div id="homeCarousel" class="carousel slide" data-ride="carousel">

      <ol class="carousel-indicators"  v-for="(slider,index) in sliders" :key="slider.imageDesktopURL">
        <li data-target="#homeCarousel" :data-slide-to="index" :class="{ active: index===0 }"></li>
      </ol>

      <div class="carousel-inner">

        <div class="item" :class="{ active: index===0 }" v-for="(slider,index) in sliders" :key="slider.imageDesktopURL">
          <router-link :to="slider.link">
            <img :src="slider.imageMobileURL" v-if="isMobile()">
            <img :src="slider.imageDesktopURL" v-else>
            <!-- <img src="/static/img/test/banner-icbc.jpg"> -->
          </router-link>
        </div>

      </div>

      <a class="left carousel-control hidden-xs" href="#homeCarousel" data-slide="prev">
        <img class="icon-prev" src="/static/img/app/fa-arrow-left-home.png">
      </a>
      <a class="right carousel-control hidden-xs" href="#homeCarousel" data-slide="next">
        <img class="icon-next" src="/static/img/app/fa-arrow-right-home.png">
      </a>

    </div>

  </section>
</template>

<script>
    import Api from '@/Api'
    import Mobile from '@/mixing/mobile'

    export default {
        data(){
          return {
            sliders:[]
          };
        },
      mixins: [Mobile],
        mounted(){
          Api().get('?func=getSliders').then(data=>{
            if (data.data.success){
              this.sliders = data.data.payload.sliders;
            }else{
              this.sliders = [];
            }

          }).catch(err=>{

          });
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Banner.vue